import { useCallback, useState } from "react";
import { IPaginationPayload } from "../../../interfaces/shared/IPaginationPayload";
import CompanyUsersTable from "./tables/CompanyUsersTable";
import { useGetCompanyUsersQuery } from "../../../store/company-users/companyUsersApi";
import Button from "../../../shared/button";
import { useNavigate } from "react-router-dom";

const CompanyUsers = () => {
	const navigate = useNavigate();
	const [paginationState, setPaginationState] = useState<IPaginationPayload>({
        pageNumber: 1,
        pageSize: 10,
    });
	const {data, isLoading} = useGetCompanyUsersQuery(paginationState);

	const handleAddNewCompanyUser = useCallback(()=>{
		navigate('/users/create')
	}, [])
	return (
		<div>
			<div>
				<p className='page-title'>Company users</p>
			</div>
			<div className='my-7 flex flex-row justify-end min-w-[100%]'>
                    <Button
                        label={'Add New User'}
                        onClickButton={handleAddNewCompanyUser}
                        className={'btn-primary !col-span-2'}
                    />
            </div>
			<CompanyUsersTable 
				rows={data?.data?.elements || []}
				paginationData={data?.data.page}
				rowsLoading={isLoading}
				setPaginationState={setPaginationState}
			/>
		</div>
	)
}

export default CompanyUsers;